import { render, staticRenderFns } from "./GiftCardsHeader.vue?vue&type=template&id=1f221c28&scoped=true&"
import script from "./GiftCardsHeader.vue?vue&type=script&lang=js&"
export * from "./GiftCardsHeader.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardsHeader.vue?vue&type=style&index=0&id=1f221c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f221c28",
  null
  
)

export default component.exports